import userManagementImg from '../../images/aci/usermanagement.png';
import userAnalyticsImg from '../../images/aci/aci.png';

export const IMAGE_SCREENS = {
    'user-management': {
        imageSrc: userManagementImg,
        alt: 'User Management',
    },
    'user-analytics': {
        imageSrc: userAnalyticsImg,
        alt: 'User Analytics',
    },
};

export const MODULE_ROUTES = {
    userManagement: '/dashboard/aci/user-management',
    userAnalytics: '/dashboard/aci/user-analytics',
};

export const HUB_TILES = [
    { key: 'user-management', label: 'User Management', link: MODULE_ROUTES.userManagement, icon: '👤', sub: 'Manage users & access' },
    { key: 'user-analytics', label: 'User Analytics', link: MODULE_ROUTES.userAnalytics, icon: '📊', sub: 'Usage & activity insights' },
];

export const getModuleFromPath = (pathname) => {
    const normalizedPath = pathname.replace(/\/$/, '');

    if (normalizedPath === '/dashboard/aci') {
        return 'hub';
    }
    if (normalizedPath.includes('/user-management')) return 'user-management';
    if (normalizedPath.includes('/user-analytics')) return 'user-analytics';
    return 'hub';
};
